function initDiscovery(root = document) {
  root.querySelectorAll('[data-discovery-filters]').forEach(filters => {
    if (filters.dataset.ready) return;
    filters.dataset.ready = 'true';
    const selects = [...filters.querySelectorAll('select')];
    selects.forEach(select => select.addEventListener('change', () => {
      const kept = (filters.dataset.activeTags || '').split('|').filter(tag => tag && !selects.some(s => tag.startsWith(s.dataset.discoveryPrefix))).map(tag => tag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
      const tags = [...kept, ...selects.map(s => s.value).filter(Boolean)];
      const url = new URL(filters.dataset.collectionUrl, location.origin);
      if (tags.length) url.pathname += '/' + tags.join('+');
      url.search = location.search; url.searchParams.delete('page');
      location.assign(url.href);
    }));
  });
}
document.addEventListener('DOMContentLoaded', () => initDiscovery());
document.addEventListener('shopify:section:load', event => initDiscovery(event.target));
